import { render, staticRenderFns } from "./industry.vue?vue&type=template&id=ec69e11a&scoped=true"
import script from "./industry.vue?vue&type=script&lang=js"
export * from "./industry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec69e11a",
  null
  
)

export default component.exports